/**
 * Is this FLOOR texture region the shower floor?
 *
 * Four markers because four writers exist and they don't agree: the cloud
 * tools stamp `surfaceType` + `label` + a `region_shower_` id, while the
 * floor texture editor's "Add Shower Floor" writes a `showerfloor_` id with
 * only `surfaceType`. Matching one marker alone misses a real pan.
 *
 * Floor regions only — shower WALL regions share the `region_shower_` prefix
 * (`region_shower_<wallId>`), so this would be a lie applied to a wall.
 *
 * @param {Object} region
 * @returns {boolean}
 */
function isShowerFloorRegion(region) {
  return (
    region?.surfaceType === 'showerFloor' ||
    region?.label === 'Shower Floor' ||
    region?.regionId?.startsWith('region_shower_') === true ||
    region?.regionId?.startsWith('showerfloor_') === true
  );
}

module.exports = { isShowerFloorRegion };
